import { createAction, props } from '@ngrx/store';
import { Sector, Template, TemplateProperty } from '../models/sector.model';

// Load Sectors
export const loadSectors = createAction(
  '[Sectors] Load Sectors',
  props<{ pageNumber: number; pageSize: number }>()
);
export const loadSectorsSuccess = createAction(
  '[Sectors] Load Sectors Success',
  props<{ sectors: Sector[] }>()
);
export const loadSectorsFailure = createAction(
  '[Sectors] Load Sectors Failure',
  props<{ error: any }>()
);

// Load Single Sector
export const loadSector = createAction('[Sectors] Load Sector', props<{ id: string }>());
export const loadSectorSuccess = createAction(
  '[Sectors] Load Sector Success',
  props<{ sector: Sector }>()
);
export const loadSectorFailure = createAction(
  '[Sectors] Load Sector Failure',
  props<{ error: any }>()
);

// Create Sector
export const createSector = createAction('[Sectors] Create Sector', props<{ sector: Sector }>());
export const createSectorSuccess = createAction(
  '[Sectors] Create Sector Success',
  props<{ sector: Sector }>()
);
export const createSectorFailure = createAction(
  '[Sectors] Create Sector Failure',
  props<{ error: any }>()
);

// Update Sector
export const updateSector = createAction(
  '[Sectors] Update Sector',
  props<{ id: string; sector: Sector }>()
);
export const updateSectorSuccess = createAction(
  '[Sectors] Update Sector Success',
  props<{ sector: Sector }>()
);
export const updateSectorFailure = createAction(
  '[Sectors] Update Sector Failure',
  props<{ error: any }>()
);

// Delete Sector
export const deleteSector = createAction('[Sectors] Delete Sector', props<{ id: string }>());
export const deleteSectorSuccess = createAction(
  '[Sectors] Delete Sector Success',
  props<{ id: string }>()
);
export const deleteSectorFailure = createAction(
  '[Sectors] Delete Sector Failure',
  props<{ error: any }>()
);

// Templates
export const loadTemplates = createAction('[Sectors] Load Templates');
export const loadTemplatesSuccess = createAction(
  '[Sectors] Load Templates Success',
  props<{ templates: Template[] }>()
);
export const loadTemplatesFailure = createAction(
  '[Sectors] Load Templates Failure',
  props<{ error: any }>()
);

// Template Properties
export const loadTemplateProperties = createAction(
  '[Sectors] Load Template Properties',
  props<{ templateId: string; category: string }>()
);
export const loadTemplatePropertiesSuccess = createAction(
  '[Sectors] Load Template Properties Success',
  props<{ properties: TemplateProperty[] }>()
);
export const loadTemplatePropertiesFailure = createAction(
  '[Sectors] Load Template Properties Failure',
  props<{ error: any }>()
);

// Clear selected sector
export const clearSelectedSector = createAction('[Sectors] Clear Selected Sector');

export const updatePagination = createAction(
  '[Sectors] Update Pagination',
  props<{ currentPage?: number; pageSize?: number; totalItems?: number }>()
);
